import { IState } from "@redux/store.types";
import { generateDefaultSelectors, getApiDataState } from "@redux/utils";

import { $BoxCountModuleName } from "./boxCount.types";

const { isLoading, error } = generateDefaultSelectors($BoxCountModuleName);

const getBoxCount = (sku: string) => (state: IState) => {
    if (!sku) return undefined;

    return getApiDataState(state, $BoxCountModuleName)?.[sku]?.data?.count;
};
export { isLoading, error, getBoxCount };
